<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>
  <div *ngIf="loadError" class="text-red-600">{{ loadError }}</div>

  <div *ngIf="rrd && proposal">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>          <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>    <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>      <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Manufacturer</td> <td class="value">{{ product?.productType?.manufacturer?.name }}</td></tr>
        <tr><td class="label">Style</td>        <td class="value">{{ product?.productType?.style }}</td></tr>
        <tr><td class="label">Features</td>     <td class="value">{{ variantText }}</td></tr>
        <tr><td class="label">Qty</td>          <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Decision</td>     <td class="value">{{ rrd.decision }}</td></tr>
        <tr *ngIf="rrd.chargeRestockFee">
          <td class="label">Restocking charge</td>
          <td class="value">{{ proposal?.restockFee | currency }}</td>
        </tr>
      </table>
    </div>

    <!-- Branch 1: $0 settlement -->
    <div *ngIf="isZeroBranch" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Settlement: $0.00</div>
      <div class="text-sm text-muted">
        The item has been placed in account-owned inventory. No money moves. No credit memo will be created.
        Confirming will move this RRD to CLOSED with an audit note.
      </div>
    </div>

    <!-- Branch 2: clean credit -->
    <div *ngIf="isCreditBranch" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Proposed Transaction</div>
      <table class="qb-info-table">
        <tr>
          <td class="label">Gross credit</td>
          <td class="value">{{ proposal.grossCreditAmt | currency }}</td>
        </tr>
        <tr *ngIf="proposal.restockFee > 0">
          <td class="label">Restock fee</td>
          <td class="value">−{{ proposal.restockFee | currency }}</td>
        </tr>
        <tr class="font-semibold">
          <td class="label">Transaction amount</td>
          <td class="value">{{ proposal.creditAmt | currency }}</td>
        </tr>
        <tr>
          <td class="label">Transaction type</td>
          <td class="value">{{ transactionTypeLabel }}</td>
        </tr>
      </table>
      <div class="text-sm text-muted mt-2">
        Confirming will create the {{ transactionTypeLabel }} (status: Unposted), move this RRD to CLOSED, and emit an audit note.
        The QuickBooks poster will pick up the {{ transactionTypeLabel }} on its next run.
      </div>
    </div>

    <!-- Branch 3: unreconcilable -->
    <div *ngIf="isUnreconcilableBranch" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2 text-red-600">Cannot Settle Cleanly</div>
      <div class="text-sm mb-3">
        The system could not produce a clean settlement for this RRD. The reason is shown below.
        You can edit it before moving this RRD to UNRECONCILED — operators in the Reconcile workflow
        will use this explanation as the starting point.
      </div>
      <div class="grid grid-cols-12 gap-3 items-start">
        <label class="col-span-3 font-semibold pt-2">Explanation</label>
        <textarea pTextarea
                  rows="4"
                  class="col-span-9 w-full"
                  title="Reconciliation explanation"
                  [(ngModel)]="reconciliationExplanation"
                  [disabled]="submitting"></textarea>
      </div>
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-check"
            [disabled]="!canSubmit"
            (click)="confirm()">
      <span>{{ confirmLabel }}</span>
    </button>
  </div>
</div>
